import { Box, Typography, FormControlLabel, Radio, Stack } from "@mui/material";
import "./PujaPlanSelector.scss";
import { truncateToTwoDecimals } from "../../utils/HelperFunctions";

const PujaPlanSelector = ({
  isPlanSelected,
  title,
  description,
  price,
  onChange,
  currency,
  frequency,
  discount,
  cuttedPrice,
  descriptionVariant,
}: any) => {
  return (
    <Box
      className={`planCardInfo ${
        isPlanSelected ? "selected" : ""
      } desc-${descriptionVariant}`}
      onClick={(e: any) => {
        e.preventDefault();
        onChange();
      }}
      sx={{ cursor: "pointer" }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
      >
        <Box className="planLeftBlock">
          <FormControlLabel
            control={
              <Radio
                checked={isPlanSelected}
                onChange={() => onChange()}
                className="orangeRadio"
                onClick={(e: any) => e.stopPropagation()}
              />
            }
            label={
              <Typography className="radioLabel">{title ?? ""}</Typography>
            }
          />
          <Box className="rightContent">
            {cuttedPrice > 0 && (
              <Box display="flex" alignItems="center">
                <Typography className="strikeThroughPrice">
                  {currency}
                  {cuttedPrice}
                </Typography>
                <Typography className="discountpercent">
                  {discount}% Off
                </Typography>
              </Box>
            )}

            <Typography className="priceInfo">
              {price > 0
                ? `${currency}${truncateToTwoDecimals(price * frequency)}`
                : `${discount}% Discount`}
            </Typography>

            {price > 0 && (
              <Typography className="itemCount">{`(${currency}${truncateToTwoDecimals(
                price
              )} * ${frequency})`}</Typography>
            )}
          </Box>
          <Box className="leftContent">
            <Typography>{description ?? ""}</Typography>
          </Box>
        </Box>
      </Stack>
    </Box>
  );
};

export default PujaPlanSelector;
